import React from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, Button, ActionIcon } from '@mantine/core';
import { Globe, Check } from '@phosphor-icons/react';
import { SUPPORTED_LANGS } from '../i18n';

const LABELS = { pl: 'Polski', en: 'English', de: 'Deutsch' };

// Przełącznik języka PL/EN/DE. variant='button' dla nagłówka marketingowego,
// variant='icon' (domyślnie) dla paska panelu.
export default function LanguageSwitcher({ variant = 'icon', size = 'md' }) {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || 'pl').slice(0, 2);

  const change = (code) => {
    if (code !== current) i18n.changeLanguage(code);
  };

  const target = variant === 'button' ? (
    <Button
      variant="subtle"
      color="gray"
      size={size}
      leftSection={<Globe size={18} />}
      styles={{ root: { color: 'black', fontSize: 17 } }}
    >
      {current.toUpperCase()}
    </Button>
  ) : (
    <ActionIcon variant="subtle" color="gray" size="lg" aria-label={t('lang.change')}>
      <Globe size={20} />
    </ActionIcon>
  );

  return (
    <Menu shadow="md" width={160} position="bottom-end" withArrow>
      <Menu.Target>{target}</Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>{t('lang.change')}</Menu.Label>
        {SUPPORTED_LANGS.map((code) => (
          <Menu.Item
            key={code}
            onClick={() => change(code)}
            rightSection={code === current ? <Check size={14} weight="bold" /> : null}
            fw={code === current ? 600 : 400}
          >
            {LABELS[code] || code.toUpperCase()}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
